<div class="skeleton">
  <div class="item">
    <span class="item__label skeleton--animated"></span>
  </div>
</div>
